import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from '@angular/core';
import { GATEWAY_TO_FEATURE_MAP, PAYMENT_GATEWAYS, PAYMENT_METHOD } from '@client-monorepo/payment/purchase';
import { InAppTacResponse } from '@client-monorepo/common/user';
import { MessageService } from '@client-monorepo/common/utilities';
import { WalletApiService } from '@client-monorepo/payment/wallet';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';

@Component({
  selector: 'payment-purchase-pay-method-picker',
  standalone: true,
  imports: [],
  templateUrl: './pay-method-picker.component.html',
  styleUrls: ['./pay-method-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PayMethodPickerComponent {
  amount = 0;

  balance = 0;

  ticket: string;

  walletError = false;

  tacResponse: InAppTacResponse;

  status = {
    IPG: true,
    WALLET: false,
    DPG: false,
  };

  constructor(
    private bottomSheetService: NgxBottomSheetService,
    private messageService: MessageService,
    private walletApiService: WalletApiService,
    private changeDetectorRef: ChangeDetectorRef,
  ) {
    const data = this.bottomSheetService?.data();
    this.amount = data.amount;
    this.ticket = data.ticket;
    this.tacResponse = data.tacResponse;

    this.getWalletBalance();
    this.checkWalletStatus();
  }

  private getWalletBalance() {
    // todo unComment after adding WalletApiClient service
    this.walletApiService.getWalletBalance().subscribe(
      (balanceResponse) => {
        this.balance = balanceResponse.amount;
        this.changeDetectorRef.detectChanges();
      },
      (e) => {
        this.walletError = true;
      },
    );
  }

  private checkWalletStatus() {
    this.status.IPG = this.tacResponse.gateways.indexOf(PAYMENT_GATEWAYS.IPG) >= 0;
    this.status.WALLET = this.tacResponse.gateways.indexOf(PAYMENT_GATEWAYS.WALLET) >= 0;
    this.status.DPG = this.tacResponse.gateways.indexOf(PAYMENT_GATEWAYS.DPG) >= 0;
  }

  itemClick(method: keyof typeof PAYMENT_METHOD) {
    if (method === 'WALLET' && this.walletError) {
      this.messageService.showErrorMessage('در حال حاضر امکان استفاده از کیف پول وجود ندارد');
      return;
    }

    if (method === 'WALLET' && this.balance < this.amount) {
      this.messageService.showErrorMessage('موجودی کافی نیست');
      return;
    }

    const FEATURE_CODE = GATEWAY_TO_FEATURE_MAP[method as keyof typeof GATEWAY_TO_FEATURE_MAP];
    const feature = this.tacResponse.features[FEATURE_CODE];
    this.bottomSheetService.outputData.set({ method, feature });
    this.bottomSheetService.closeBottomSheet();
  }
}
